import { jsx as _jsx } from "react/jsx-runtime";
import { FeatureFlag, useFeatureFlag } from '../../Contexts/FeatureFlagContext';
import { IframePaymentPage } from './IframePaymentPage';
import { DirectPaymentStep } from './DirectPaymentPage';
export var PaymentPage = function () {
    var isDirectPayment = useFeatureFlag(FeatureFlag.DIRECT_PAYMENT);
    return isDirectPayment ? _jsx(DirectPaymentStep, {}) : _jsx(IframePaymentPage, {});
};
